import { Component, Input } from '@angular/core';
import { AutoCompleteSearchDropdownOptionsI } from '../autocomplete-field/autocomplete-field.interface';

@Component({
  selector: 'app-state-city-rto-selector',
  templateUrl: './state-city-rto-selector.component.html',
  styleUrls: ['./state-city-rto-selector.component.scss']
})
export class StateCityRtoSelectorComponent {
  @Input('lob') lob: string;
  @Input('required') required: boolean = false;

  controlName = 'cityrtoselector';

  label: string = "State/City/RTO";

  autoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI = {
      searchApiUrl: '/services/api/v1/advance_rule_search/rttos',
      dataApiUrl: '/services/api/v1/advance_rule_search/get-state-city-rto',
      queryParamKey: 'search_text',
      dataIdKey: 'combined_value',
      dataNameKey: 'abbr',
      toolTipType: 'items',
      requiredField:true
  }

  ngOnInit() {
    if (['motor', 'cv', 'motor4W'].indexOf(this.lob) == -1) {
      this.label = "State/City";
    }
    this.autoCompleteFieldOptions.searchApiUrl = `/services/api/v1/advance_rule_search/rttos?lob=${this.lob}`;
    this.autoCompleteFieldOptions.requiredField = this.required;
  }
}
